import { RGBColor } from '../../types/shared/Account';

export default function getColorString({ r, g, b, a }: RGBColor) {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
